import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {wwData$} from '@px/streams/worker-data';
import Msg = ww.Msg;

export const assetsOverview$ = new BehaviorSubject<MarginAssetsOverview>(createInitMarginAssetsOverview());
export const crossAccountRiskLevel$ = assetsOverview$.pipe(
  map(
    (o): MarginAccountRiskLevel => ({
      riskLevel: o.riskLevel,
      riskLevelEr: o.riskLevelEr,
    })
  )
);

wwData$.pipe(filter<Msg<MarginAssetsOverview>>((o) => o.type === 'margin-assets-overview')).subscribe((msg: Msg<MarginAssetsOverview>) => assetsOverview$.next(msg.data));

function createInitMarginAssetsOverview(): MarginAssetsOverview {
  return {
    totalEquityEv: '0',
    totalDebtEv: '0',
    netEquityEv: '0',
    totalEquityUsd: '--',
    totalDebtUsd: '--',
    netEquityUsd: '--',
    totalEquityBtc: '--',
    totalDebtBtc: '--',
    netEquityBtc: '--',
    maxTransferOutValueEv: '0',
    riskLevel: '--',
    riskLevelEr: 'Infinity',
    totalAvailableEv: '0',
    totalAvailableUsd: '--',
    totalMarginEv: '0',
    totalMarginUsd: '--',
    totalFreezeEv: '0',
    totalFreezeUsd: '--',
  };
}
